module.exports = __webpack_public_path__ + "media/images/people/boy-11-af6b0119ffad72762b8b27d4fcbd77c4.webp";